import createIcon from "./createIcon";

export const FolderEmptyIcon = createIcon('FolderEmpty', (props) => {
	return (
		<svg {...props} viewBox="0 0 24 24" fill="none">
			<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9a2 2 0 00-2 2v5a2 2 0 01-2 2z" />
		</svg>
	)
});

